(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-video"] && !Shopify.designMode) return;
  try {
    

    const triggerImage = document.getElementById("trigger");
    const videoElement = document.getElementById("video");
   const play = document.getElementById("play");

    triggerImage.addEventListener("click", function() {
      // const newSrc = triggerImage.getAttribute("data-src");
      const newSrc2 = videoElement.getAttribute("data-src");
      triggerImage.classList.add("hidden");
      play.classList.add("hidden");
      videoElement.setAttribute("src", newSrc2);
      
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  } catch(e) { console.error(e); }
})();
})();
